module.exports = __webpack_public_path__ + "img/Icon-block-manager-24px.d2da936e.svg";